<app-mandate-holder-form [initialData]="initialData" testIdPrefix="wizard-"></app-mandate-holder-form>
